import React from "react";
import styled from "styled-components";
import { PrimaryButton } from "./shared/Button";
import PlayArrowIcon from "@mui/icons-material/PlayArrowOutlined";
import { Title } from "./shared/Title";
import { Subtitle } from "./shared/Subtitle";
import { scrollToSection } from "./shared/utils";

const Bg = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin: 0 auto;
`;

const WrapperStyled = styled.div`
  max-width: 1000px;
  margin: auto;
  padding: 70px 5%;
`;

const ContentSyled = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: 1fr;
  margin-top: 40px;

  @media (min-width: 1024px) {
    grid-template-columns: 2fr 1fr;
  }
`;

const ListStyled = styled.ul(
  ({ theme }) => `
  margin-right: 50px;
  list-style: none;
  padding-left: 0;

  & li {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  & svg {
    margin-right: 10px;
    color: ${theme.colors.blue}
  }
`
);

const PriceBoxStyled = styled.div`
  background-color: white;
  border-radius: 5px;
  padding: 25px 50px;
  height: 210px;
  text-align: center;
`;

const NextEdition = styled.p`
  color: ${({ theme }) => theme.colors.orange};
  margin-top: 0;
  font-weight: 500;
`;

const Price = styled.p`
  font-size: 40px;
  margin-top: -10px;
  margin-bottom: 30px;
  font-weight: 600;
`;

export const Prices = () => {
  return (
    <Bg>
      <WrapperStyled>
        <Subtitle>Precios</Subtitle>
        <Title>Invierte en tu futuro</Title>
        <ContentSyled>
          <div>
            <ListStyled>
              <li>
                <PlayArrowIcon />
                Más de 50 horas de clases inéditas{" "}
              </li>
              <li>
                <PlayArrowIcon />
                Programa part time de 6 meses
              </li>
              <li>
                <PlayArrowIcon />
                Sigue la clase online en vivo o descarga la grabación
              </li>
              <li>
                <PlayArrowIcon />
                Acceso de por vida a las clases grabadas y al manual
              </li>
              <li>
                <PlayArrowIcon />
                Tutorías con los docentes{" "}
              </li>
              <li>
                <PlayArrowIcon />
                Te enseñamos cómo se trabaja realmente en el sector IT
              </li>
              <li>
                <PlayArrowIcon />
                Aprenderás metodologías ágiles
              </li>
              <li>
                <PlayArrowIcon />
                Alta empleabilidad como Frontend Developer
              </li>
            </ListStyled>
          </div>
          <PriceBoxStyled>
            <NextEdition>Próxima edición</NextEdition>
            <p>Enero 2025 - Junio 2026</p>
            <p>
              <s>3.450€</s>
            </p>
            <Price>2.950€</Price>
            <PrimaryButton onClick={() => scrollToSection("contact")}>
              <b>Infórmate</b>
            </PrimaryButton>
          </PriceBoxStyled>
        </ContentSyled>
      </WrapperStyled>
      <span id="faq"></span>
    </Bg>
  );
};
